/**
 * Lo que se ve mientras el asistente trabaja (D56) y la transcripción debajo de un audio (D57).
 */
import { Button, Typography } from "antd";
import {
  textoDeActividad,
  type ActividadDelAsistente,
  type EstadoDeTranscripcion,
} from "./agent-activity";

const { Text } = Typography;

const ESTILO_PUNTOS = `
@keyframes xcons-asistente-punto { 0%, 80%, 100% { opacity: .2 } 40% { opacity: 1 } }
.xcons-asistente-puntos span { animation: xcons-asistente-punto 1.4s infinite both; }
.xcons-asistente-puntos span:nth-child(2) { animation-delay: .2s; }
.xcons-asistente-puntos span:nth-child(3) { animation-delay: .4s; }
`;

/** «Asistente de prueba tecnopor está buscando productos…», con los puntos animados. */
export function ActividadDelAsistenteRow({
  actividad,
}: {
  actividad: ActividadDelAsistente;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        marginTop: 6,
        fontSize: 12,
        color: "#595959",
        fontStyle: "italic",
      }}
    >
      <style>{ESTILO_PUNTOS}</style>
      {textoDeActividad(actividad)}
      <span className="xcons-asistente-puntos" aria-hidden>
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </span>
    </div>
  );
}

/**
 * Debajo de un audio: «Transcribiendo…», el texto, o que no se pudo —con **Transcribir** para pedirla
 * otra vez—. Sin transcripción pedida, sólo el botón, y sólo para quien puede escribir en el canal.
 */
export function TranscripcionDelAudio({
  transcript,
  estado,
  puedePedir,
  onPedir,
}: {
  transcript: string | null | undefined;
  estado: EstadoDeTranscripcion | undefined;
  puedePedir: boolean;
  onPedir: () => void;
}) {
  const pedir = puedePedir ? (
    <Button
      type="link"
      size="small"
      style={{ padding: 0, height: "auto", fontSize: 12 }}
      onClick={onPedir}
    >
      Transcribir
    </Button>
  ) : null;
  if (estado === "pending")
    return (
      <Text
        type="secondary"
        italic
        style={{ display: "block", marginTop: 4, fontSize: 12 }}
      >
        Transcribiendo…
      </Text>
    );
  if (estado === "done" && transcript)
    return (
      <Text
        type="secondary"
        style={{
          display: "block",
          marginTop: 4,
          fontSize: 12,
          whiteSpace: "pre-wrap",
        }}
      >
        «{transcript}»
      </Text>
    );
  if (estado === "failed")
    return (
      <div style={{ marginTop: 4, fontSize: 12 }}>
        <Text type="secondary" italic style={{ fontSize: 12, marginRight: 6 }}>
          No se pudo transcribir.
        </Text>
        {pedir}
      </div>
    );
  return pedir ? <div style={{ marginTop: 4 }}>{pedir}</div> : null;
}
